import { useTranslation } from "react-i18next";
import PlayoffOverview from "./overview";
import PlayoffHistory from "./history";
import InfoCircle from "../infoCircle";

const PlayoffContent = ({ leagueData, userRoundData }) => {
  const { t } = useTranslation();
  const { userCount } = leagueData;

  const settledRoundCount = Object.values(leagueData?.rounds).reduce(
    (count, round) => {
      if (round.settled) {
        return count + 1;
      }
      return count;
    },
    0
  );

  return (
    <>
      {!userRoundData && (
        // <swiper-slide>
        <div className="flex h-24 items-center justify-center">
          <InfoCircle
            label={t("lobby.card.players", {
              count: userCount,
            })}
            value={userCount}
          />
        </div>
        // </swiper-slide>
      )}
      {userRoundData && (
        // <swiper-slide>
        <div className="flex h-24 items-center justify-center">
          <PlayoffOverview leagueData={leagueData} />
        </div>
        // </swiper-slide>
      )}
      {/*   {userRoundData && settledRoundCount >= 1 && (
        <swiper-slide>
          <div className="flex h-24 items-center justify-center">
            <PlayoffHistory leagueData={leagueData} />
          </div>
        </swiper-slide>
      )} */}
    </>
  );
};

export default PlayoffContent;
